import { useCallback, useEffect, useState } from 'react';
import { useAuthStatus } from '@framework/auth/authStatus';
import { UserSurveyOperation } from './UserSurveyOperation';

export const useUserSurveyForm = () => {
  const [showSurveyForm, setShowSurveyForm] = useState(false);
  const [showThanks, setShowThanks] = useState<boolean>(false);
  const [surveyId, setSurveyId] = useState('');

  const auth = useAuthStatus();

  const prepare = useCallback(async () => {
    const displayStatus = await UserSurveyOperation.getDisplayStatus(auth);
    if (displayStatus.status === 'Display') {
      setShowSurveyForm(true);
      setSurveyId(displayStatus.id);
    } else {
      setShowSurveyForm(false);
    }
  }, [auth]);

  useEffect(() => {
    prepare();
  }, [prepare]);

  const handleCloseModal = useCallback(() => {
    setShowSurveyForm(false);
  }, []);

  const handleCloseThanksModal = useCallback(() => {
    setShowThanks(false);
  }, []);

  const handleAnswerCompleted = useCallback(() => {
    setShowSurveyForm(false);
    setShowThanks(true);
  }, []);

  return {
    showSurveyForm,
    showThanks,
    surveyId,
    handleCloseModal,
    handleCloseThanksModal,
    handleAnswerCompleted,
  };
};
